<template>
  <div class="content contacts-t-wrap"
       :class="{'contacts-t-wrap-no-banner': !isScrollTop, 'contacts-list': this.isList}
">
    <div class="flex sm:block sm:justify-start items-center px-8 sm:px-4 py-3 shadow-md bg-white">

     <div v-if="isList" class="flex-grow-0 cut-nowrap sm:mb-3">
        <b class="font-semibold"><router-link to="/lists" class="text-xl m-0 sm:text-xl sm:mr-2">Lists</router-link></b>
        <el-divider direction="vertical"></el-divider>
        <span v-if="listInfo" class="text-sm text-gray-500 ">{{listInfo.name}}</span>
      </div>

      <div v-else class="flex-grow-0 cut-nowrap sm:mb-3">
        <span class="text-xl m-0 sm:text-xl sm:mr-2 font-semibold">Contacts</span>
        <el-divider direction="vertical"></el-divider>
        <span v-if="contactsLoaded"><i v-if="selectedCount" class="selected-donors-count">{{selectedCount}}</i>
              {{selectedCount ? 'of' : ''}}
              <i class="total-donors-count"></i>{{getDonorsCount('all')}} Total
        </span>

      </div>

      <div class="flex-grow text-right">
        <div class="search mr-6 ">
          <input class="input-sm"
                 type="text"
                 v-model="searchDonorsName"
                 placeholder="Search by name...">
        </div>

        <el-dropdown v-if="!isList" trigger="click" @command="handleCommand">
          <el-button type="primary" size="medium">
            <font-awesome-icon class="mr-2 md:mr-0"
                               :icon="['fas', 'ellipsis-v']"/> <span class="md:hidden">Manage Contacts</span>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="!isList" :command="['add-contact']">
              <font-awesome-icon class="mr-2 sm:mr-0" :icon="['far', 'user-plus']"/> Add Contact</el-dropdown-item>
            <el-dropdown-item :command="['download-contacts']">
              <font-awesome-icon class="mr-2 sm:mr-0" :icon="['far', 'download']"/> Download Contacts</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown v-else-if="isList && listInfo" trigger="click" @command="handleCommand">
          <el-button type="primary" size="medium">
            <font-awesome-icon class="mr-2 md:mr-0"
                               :icon="['far', 'ellipsis-v']"/> <span class="md:hidden">Manage List</span>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="['add-users']">Add Users</el-dropdown-item>
            <el-dropdown-item v-if="selectedCount" :command="['remove-users']">Remove Users</el-dropdown-item>
            <el-dropdown-item :command="['send-message', listInfo.id]">Send Message</el-dropdown-item>
            <el-dropdown-item :command="['download-list']">Download List</el-dropdown-item>
            <el-dropdown-item :command="['rename-list']">Rename List</el-dropdown-item>
            <el-dropdown-item :command="['delete-list']">Delete List</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>

    <div class="d-donors" style="max-height: none">
      <div class="d-block shadow-md" >
        <div class="advanced-tools-wrap text-right" :class="{'advanced-tools-list': isList}">

          <el-dropdown ref="moreColumnDd" trigger="click" @command="handleCommand">

            <el-button size="medium"><font-awesome-icon :icon="['far', 'sliders-h']" class="mr-3" /><b>More Columns</b>
              <font-awesome-icon class="ml-1 text-xs text-gray-400" :icon="['far', 'chevron-down']"/>
            </el-button>

            <el-dropdown-menu class="advanced-tools-wrap select-tools" slot="dropdown">
              <div v-if="allColumns.length>2" class="row columns-settings">
                <div class="col-sm-4 column-1">
                  <div class="category">
                    <h3>{{allColumns[0].name}}</h3>
                    <label class="checkbox-container checkbox-container-label">Name & Email
                      <input type="checkbox" checked="checked" disabled="disabled">
                      <span class="checkmark"></span>
                    </label>
                    <label
                        v-for="(column, index) in allColumns[0].columns"
                        :key="index"
                        class="checkbox-container checkbox-container-label">{{column.title}}
                      <input type="checkbox"
                             class="selected-columns"
                             :value="column.key"
                             v-model="selectedColumns">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-4 column-2">
                  <div class="category">
                    <h3>{{allColumns[1].name}}</h3>
                    <label
                        v-for="(column, index) in allColumns[1].columns"
                        :key="index"
                        class="checkbox-container checkbox-container-label">{{column.title}}
                      <input type="checkbox"
                             class="selected-columns"
                             :value="column.key"
                             v-model="selectedColumns">
                      <span class="checkmark"></span>
                    </label>

                    <h3>{{allColumns[2].name}}</h3>
                    <label
                        v-for="(column, index) in allColumns[2].columns"
                        :key="index+'_2'"
                        class="checkbox-container checkbox-container-label">{{column.title}}
                      <input type="checkbox"
                             class="selected-columns"
                             :value="column.key"
                             v-model="selectedColumns">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-4 column-3">
                  <div v-if="allColumns.length > 3" class="category">
                    <h3>{{allColumns[3].name}}</h3>
                    <label
                        v-for="(column, index) in allColumns[3].columns"
                        :key="index"
                        class="checkbox-container checkbox-container-label">{{column.title}}
                      <input type="checkbox"
                             class="selected-columns"
                             :value="column.key"
                             v-model="selectedColumns">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>

              </div>
              <button type="submit"
                      class="btn btn-sm update-columns-btn"
                      v-on:click.prevent="updateColumns"

              ><span></span>Update Columns
              </button>
            </el-dropdown-menu>

          </el-dropdown>

          <el-dropdown v-if="!isList && selectedCount>0" class="ml-4" trigger="click" @command="handleCommand">
            <el-button size="medium"><b>Actions</b>
              <font-awesome-icon class="ml-1 text-xs text-gray-400" :icon="['far', 'chevron-down']"/>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="['create-list']">Create List</el-dropdown-item>
              <el-dropdown-item :command="['send-email']">Send Email</el-dropdown-item>
              <el-dropdown-item :command="['send-message-contacts']">Send Message</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>


        </div>

        <div v-if="isList" class="donors-filters donors-filters-list clearfix">
          <div v-if="listInfo && contactsLoaded" class="filter">
            {{listInfo.name}}
          </div>
          <div v-if="listInfo && contactsLoaded" class="filter">
            {{getDonorsCount('all')}} contacts
          </div>
        </div>
        <div v-else class="donors-filters clearfix">
          <div><a href="#"
                  class="filter filter-all-donors"
                  v-on:click.prevent="selectFilter('all')"
                  :class="{'active': filterDonors === 'all'}"
          >Contacts<span v-if="donorsState === 'ready'" class="total-donors-count">{{getDonorsCount('all')}}</span></a>
          </div>
          <div>
            <a href="#"
               class="filter filter-active-donors"
               v-on:click.prevent="selectFilter('donors')"
               :class="{'active': filterDonors === 'donors'}"
            >Donors<span v-if="donorsState === 'ready'" class="active-donors-count">{{getDonorsCount('donors')}}</span></a>
          </div>
        </div>

        <!--donors-list-->
        <div class=" contacts-list">
          <div class="loading-state">Loading Contacts</div>
          <table id="contacts-table" class="row-border"></table>
        </div>

      </div>
    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <modal v-if="isUploadModal"
           v-on:close-modal="isUploadModal = false"
           :modal-name="'import-contacts'"></modal>

    <modal v-if="isCreateListModal"
           v-on:close-modal="isCreateListModal = false"
           v-on:saved="newListFromSelected"
           :modal-name="'list-modal'"></modal>

    <modal v-if="isEditListModal && listInfo"
           :listInfo="listInfo"
           v-on:close-modal="isEditListModal = false"
           v-on:saved="isEditListModal = false; refreshListInfo();"
           :modal-name="'list-modal'"></modal>

    <modal v-if="isDeleteListModal && listInfo"
           :listInfo="listInfo"
           v-on:close-modal="isDeleteListModal = false"
           v-on:deleted="isDeleteListModal = false; $router.push('/lists');"
           :modal-name="'delete-list'"></modal>

    <modal v-if="isAddUsersListModal && listInfo"
           :listInfo="listInfo"
           v-on:close-modal="isAddUsersListModal = false"
           v-on:updated="isAddUsersListModal = false; refreshListInfo();"
           :modal-name="'list-add-users'"></modal>

    <modal v-if="isCreateContactModal"
           v-on:close-modal="isCreateContactModal = false"
           v-on:done="isCreateContactModal = false; refreshListInfo();"
           :modal-name="'create-contact'"></modal>

  </div>
</template>

<script>
  /*eslint-env jquery*/
  import {addUsersToList, getMetadataColumns, getOneList, removeUserFromList} from '@/utils/api';
  import {formatMoney, ucwords, saveCSV, arrayMove} from '@/utils/utils';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import Modal from '../Modal/index.vue';
  import scrollInfoMixin from '../../mixins/scroll-info-mixin';

  import contactsMixin from './contacts-mixin';
  import {filterDonorById} from '@/utils/donors';
  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'Contacts',
    mixins: [contactsMixin, scrollInfoMixin],
    props: ['isList'],
    components: {
      DonorInfo,
      Modal,
    },
    metaInfo() {
      return {
        title: 'Contacts' + ((this.isList && this.listInfo) ? ' - ' + this.listInfo.name : ''),
      };
    },
    mounted() {
      if (this.isList) {
        getOneList(this.$route.params.listId).then(listInfo => {
          this.listInfo = listInfo;

        }).catch(() => {
          this.$router.push('/lists');
        });
      } else if (this.donorsState === 'ready') {
        this.updateDonors();
      }

      document.querySelector('.content').addEventListener('click', (e) => {
        const el = e.target.closest('.show-donor-info');

        if (el) {
          e.preventDefault();
          e.stopPropagation();

          const donorId = el.getAttribute('data-donor-id');

          this.showDonorInfo = false;
          this.showDonorId = false;

          this.$nextTick(() => {
            this.showDonorInfo = true;
            this.showDonorId = donorId;
          });
        }
      });

    },
    computed: {
      ...mapState({
        donors: state => state.donors.donors,
        donorsState: state => state.donors.donorsState,
        activeCharityId: state => state.auth.activeCharityId,
      }),
      contactsLoaded() {
        if (this.isList) {
          return this.donorsState === 'ready' && this.listInfo;
        }
        return this.donorsState === 'ready';
      },
      contacts() {
        if (this.isList) {
          if (!this.listInfo) {
            return [];
          }

          const memberIds = this.listInfo.members.map(v => parseInt(v.id)).filter((v, i, a) => a.indexOf(v) === i);
          return this.donors.filter((v) => memberIds.indexOf(parseInt(v.id)) !== -1);

        }
        return this.donors;
      },
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command){
          case 'add-contact':
            this.isCreateContactModal = true;
            break
          case 'download-contacts':
            this.downloadContacts();
            break
          case 'add-users':
            this.isAddUsersListModal = true;
            break
          case 'remove-users':
            this.removeSelectedFromList();
            break
          case 'send-message':
            this.$router.push({name: 'messagesNew', query: {'list_id': payload}});
            break
          case 'download-list':
            this.downloadContacts();
            break
          case 'rename-list':
            this.isEditListModal = true;
            break
          case 'delete-list':
            this.isDeleteListModal = true;
            break
          case 'create-list':
            this.isCreateListModal = true;
            break
          case 'send-email':
            this.sendEmailSelected();
            break
          case 'send-message-contacts':
            this.sendMessageSelected();
            break
        }
      },
      newListFromSelected(lid) {
        let uids = [];

        const dt = $('#contacts-table').DataTable();

        dt.column(0).checkboxes.selected().each(i => uids.push(i));

        addUsersToList(lid, uids).then(() => {
          this.$message('List has been created');
          dt.column(0).checkboxes.deselectAll();
          this.$router.push('/lists');
        });
      },
      downloadContacts() {

        let sortIndex = 0;
        let columns = ([].concat(...this.allColumns.map(group => group.columns))).reduce((res, val) => {
          res.push({
            name: val.key,
//            title: val.title,
            'sort-index': sortIndex++,
          });
          return res;
        }, [
          {name: 'first_name', 'sort-index': sortIndex++},
          {name: 'last_name', 'sort-index': sortIndex++},
          {name: 'email', 'sort-index': sortIndex++},
        ]);

        let phoneIndex = false;
        for (let i = 0; i < columns.length; i++) {
          if (columns[i].name === 'phone') {
            phoneIndex = i;
          }
        }

        if (phoneIndex !== false) {
          arrayMove(columns, phoneIndex, 3);
        }

        //move phone number to the position #4
        let columnHeaders = [];
        let contactsArray = [];

        columns.map((column) => {
          columnHeaders = columnHeaders.concat(this.getTableParam(column.name, null, 'header'));
        });

        this.contacts.map(donor => {

          let tmp = [].concat(...columns.map((column) => {
              let res = this.getTableParam(column.name, donor, 'data');
              if (Array.isArray(res)) {
                res = res[0];
              }

              if (column.name === 'sign-up') {
                res = moment(res).format('MM/DD/YYYY');
              }

              if (['round-ups', 'monthly', 'custom', 'totals'].indexOf(column.name) !== -1) {
                res = '$' + ((res / 100).toFixed(2));
              }
              // if (column.name === 'rup-status') {
              //   if (res) {
              //     res = (res + '').replace('complete', 'active').toUpperCase();
              //   }
              // }
              if (column.name === 'notifications') {
                res = res ? 'ON' : 'OFF';
              }
              if (column.name === 'phone') {
                if (res) {
                  res = (res + '').replace(/(\d{3})(\d{3})(\d{4,10})/, '$1-$2-$3');
                }
              }

              return [res];
            },
          ));
          tmp = tmp.map(item => {
            if (item === null) {
              item = '';
            }
            if (item === '-') {
              item = '';
            }
            return item;
          });
          contactsArray.push(tmp);
        });

        saveCSV(
          [
            columnHeaders,
            ...contactsArray,
          ],
          {
            filename: `contacts.csv`,
            addHeader: false,
          },
        );
      },
      removeSelectedFromList() {
        let checked = [];
        $('#contacts-table').DataTable().column(0).checkboxes.selected().each(i => checked.push(i));

        // const checked = [...document.querySelectorAll('.check-donors:checked')];
        const toDelCount = checked.length;
        let delCount = 0;

        [...checked].map(uid => {
          removeUserFromList(this.$route.params.listId, uid).then(() => {
            delCount++;
            if (delCount === toDelCount) {
              setTimeout(this.refreshListInfo, 500);
            }
          });
        });
      },
      refreshListInfo() {
        if (this.isList) {
          getOneList(this.$route.params.listId).then(listInfo => {
            this.listInfo = listInfo;
          });
        }
      },
      updateColumns() {
        this.$refs.moreColumnDd.hide();
        if (this.selectedColumns.length === 0) {
          return false;
        }

        this.setColumns(this.selectedColumns);

        this.updateDonors();
      },
      updateSelectedCount() {
        this.selectedCount = $('#contacts-table').DataTable().column(0).checkboxes.selected().length;
      },
      sendMessageSelected() {
        const checked = $('#contacts-table').DataTable().column(0).checkboxes.selected();

        if (!checked.length) {
          alert('Select contacts with enabled notifications.');
          return false;
        }
        let ids = [];

        for (let i = 0; i < checked.length; i++) {
          let donor = filterDonorById(checked[i], this.contacts);
          if (donor.sms_enabled) {
            ids.push(donor.id);
          }
        }
        if (ids.length) {
          this.$router.push({name: 'messagesNew', query: {'donor_ids': ids.join(',')}});
        } else {
          alert('Select contacts with enabled notifications.');
          return false;
        }
      },
      sendEmailSelected() {
        const checked = $('#contacts-table').DataTable().column(0).checkboxes.selected();//.each(i => checked.push(i));

        if (!checked.length) {
          alert('Select contact.');
        }
        let mails = [];

        for (let i = 0; i < checked.length; i++) {
          let donor = filterDonorById(checked[i], this.contacts);
          if (donor) {
            mails.push(donor.email);
          }
        }
        if (mails.length) {
          window.open('mailto:' + mails.join(','))
        }
      },
      selectFilter(filter) {
        this.filterDonors = filter;
        $('#contacts-table').DataTable().column(0).checkboxes.deselectAll();
        if (this.filterDonors === 'donors') {
          $.fn.dataTable.ext.search.length = 0;
          $.fn.dataTable.ext.search.push(
            function(settings, data) {
              return parseFloat(data[7]) > 0;
            },
          );
          $('#contacts-table').DataTable().draw();
        } else if (this.filterDonors === 'round-ups') {
          $.fn.dataTable.ext.search.length = 0;
          $.fn.dataTable.ext.search.push(
            function(settings, data) {
              return data[8] === 'complete';
            },
          );

          $('#contacts-table').DataTable().draw();
        } else {
          $.fn.dataTable.ext.search.length = 0;
          $('#contacts-table').DataTable().draw();
        }
      },
      updateDonors() {
        this.allColumns = JSON.parse(JSON.stringify(this.defaultColumns));

        getMetadataColumns().then(metadataColumns => {

          //1. add Gender, Age from metadata if exist
          let addedColumns = [];
          metadataColumns.columns.map((column) => {
            if (['age', 'gender', 'employer', 'position'].indexOf(column.name.toLowerCase()) === -1) {
              addedColumns.push({key: column.name, title: ucwords(column.name), addSortIndex: 1000});
            }
            // else {
            //   this.allColumns[0].columns.push({key: column.name, title: ucwords(column.name)});
            // }
          });

          if (addedColumns.length > 0) {
            this.allColumns[3] = {
              name: 'ADDED FIELDS',
              columns: addedColumns,
            };
          }

          this.allColumns[0].columns.push({key: 'age', title: 'Age', addSortIndex: 100});
          this.allColumns[0].columns.push({key: 'gender', title: 'Gender', addSortIndex: 100});
          this.allColumns[0].columns.push({key: 'employer', title: 'Employer', addSortIndex: 100});
          this.allColumns[0].columns.push({key: 'position', title: 'Position', addSortIndex: 100});

          //2. add Address, City, State, Zip Code
          this.allColumns[0].columns.push({key: 'address', title: 'Address', addSortIndex: 100});
          this.allColumns[0].columns.push({key: 'city', title: 'City', addSortIndex: 100});
          this.allColumns[0].columns.push({key: 'state', title: 'State', addSortIndex: 100});
          this.allColumns[0].columns.push({key: 'zip-code', title: 'Zip Code', addSortIndex: 100});

          this.selectedColumns = this.getColumns().map(c => c.key);
          this.updateDonorsTable();

        }).catch(function(error) {
// eslint-disable-next-line
          console.warn(error);
        });
      },
      resetData() {
        // this.selectedCount = 0;

        const contactsTableObj = $('#contacts-table');

        $.fn.dataTable.ext.errMode = 'none';
        if ($.fn.dataTable.isDataTable('#contacts-table')) {
          let table = contactsTableObj.DataTable();
          table.column(0).checkboxes.deselectAll();
          table.destroy();
          contactsTableObj.empty();
        }
      },
      updateDonorsTable() {
        const self = this;

        const contactsTableObj = $('#contacts-table');
        this.resetData();

        const selectedColumns = this.getColumns().map(c => c.key);

        let contactsArray = [];
        let columnHeaders = [];
        let columnDefs = [];

        this.contacts.map(donor => {
          let tmp = this.getTableParam('id_select', donor, 'data');
          tmp = tmp.concat(this.getTableParam('name', donor, 'data'));

          selectedColumns.map((column) => {
            tmp = tmp.concat(this.getTableParam(column, donor, 'data'));
          });
          contactsArray.push(tmp);
        });

        columnHeaders = this.getTableParam('id_select', null, 'header');
        columnHeaders = columnHeaders.concat(this.getTableParam('name', null, 'header'));

        selectedColumns.map((column) => {
          columnHeaders = columnHeaders.concat(this.getTableParam(column, null, 'header'));
        });

        columnDefs = this.getTableParam('id_select', null, 'column');
        columnDefs = columnDefs.concat(this.getTableParam('name', null, 'column', columnDefs.length));
        selectedColumns.map((column) => {
          columnDefs = columnDefs.concat(this.getTableParam(column, null, 'column', columnDefs.length));
        });

        columnHeaders = columnHeaders.map(ch => {
          return {'title': `<span>${ch}<span>`};
        });

        setTimeout(() => {

          const tab = contactsTableObj.DataTable(
            {
              language: {
                paginate: {
                  next: '&#9654;',
                  previous: '&#9664;',
                },
                "emptyTable": `<div class="empty-placeholder">
                  <img src="./images/44.svg" alt="No results">
                  <h3>No Contacts Available</h3>
                </div>
`
              },
              initComplete() {

                $('#contacts-table').DataTable().column(1).search(self.searchDonorsName).draw();

                self.updateSelectedCount();
              },
              stateSave: true,
              stateSaveParams: function(settings, data) {

                data.search.search = '';
                data.start = 0;
                data.length = 50;
                delete data.checkboxes;
                delete data.columns;
              },
              searching: true,
              info: false,
              lengthMenu: [50],
              scrollY: 'calc(100vh - 343px)',
              // scrollY: self.isList ? 'calc(100vh - 543px)' : 'calc(100vh - 343px)',
              scrollX: true,
              order: [[ 1, "asc" ]],
              scrollCollapse: true,
              fixedColumns: {
                leftColumns: 2,
              },
              select: {
                style: 'multi',
                className: false,
                selector: 'td:first-child',
              },
              scroller: {
                rowHeight: 64,
              },
              data: contactsArray,
              columns: columnHeaders,
              columnDefs: columnDefs,
            },
          );

          tab.
            on('select', () => this.updateSelectedCount()).
            on('deselect', () => this.updateSelectedCount());

        }, 300);
      },
      formatMoney(amount) {
        return formatMoney(amount, 0, 3);
      },
    },
    watch: {
      'isScrollTop'() {
        $('#contacts-table').DataTable().draw();
        setTimeout(() => {$('#contacts-table').DataTable().draw();}, 300);
      },
      'listInfo'() {
        if (this.isList) {
          if (this.donorsState === 'ready' && this.listInfo) {
            this.resetData();
            setTimeout(this.updateDonors, 100);
          }
        }
      },
      'donors'() {

        if (this.isList) {
          if (this.donorsState === 'ready' && this.listInfo) {
            this.updateDonors();
          }
        } else if (this.donorsState === 'ready') {
          this.updateDonors();
        }
      },
      'activeCharityId'() {
        if (this.isList) {
          this.$router.push('/lists');
        } else {
          this.resetData();
          if (this.donorsState === 'ready') {
            this.updateDonors();
          }
        }
      },
      'searchDonorsName'() {
        const ct = $('#contacts-table');
        if (ct && ct.DataTable()) {

          ct.DataTable().column(0).checkboxes.deselectAll();
          ct.DataTable().column(1).search(this.searchDonorsName).draw();

        }
      },
    },
    data() {
      return {
        listInfo: null,
        selectedCount: 0,
        isCreateListModal: false,
        isCreateContactModal: false,
        isEditListModal: false,
        isAddUsersListModal: false,
        isDeleteListModal: false,
        isUploadModal: false,
        showDonorInfo: false,
        showDonorId: null,
        searchDonorsName: '',
        filterDonors: 'all', //all|donors|round-ups
        selectedColumns: [],
        allColumns: [],
        defaultColumns: [
          {
            name: 'DEMOGRAPHIC',
            columns: [
              {
                key: 'sign-up',
                title: 'Date Created',
                'sort-param': 'created_at',
              },
            ],
          },
          {
            name: 'DONATIONS',
            columns: [
              {
                key: 'custom',
                title: 'One-time',
                'sort-param': 'custom_donation_total',
              },
              {
                key: 'monthly',
                title: 'Monthly',
                'sort-param': 'donation_total',// donation_total - custom_donation_total
              },
              {
                key: 'round-ups',
                title: 'Round-Ups',
                'sort-param': 'roundup_donation_total',
              },
              {
                key: 'totals',
                title: 'Total Donations',
                'sort-param': 'total',
              },
              // {
              //   key: 'rup-status',
              //   title: 'Round-Up Status',
              //   'sort-param': 'status',
              // },
            ],
          },
          {
            name: 'MESSAGES',
            columns: [
              {
                key: 'phone',
                title: 'Phone Number',
                'sort-param': 'phone_number',
              },
              {
                key: 'notifications',
                title: 'Texts',
                'sort-param': 'sms_enabled',
              },
            ],
          },
        ],
      };
    },
  };
</script>

<style lang="sass" scoped>
  .contacts-t-wrap
    .page-header
      .page-header-img
        padding-top: 6px

    .advanced-tools-list
      padding-top: 20px

    .donors-filters-list
      .filter:last-of-type
        font-size: 14px
        line-height: 29px

        &:after
          display: none

    .btn-plus-list
      background-image: none
      padding-left: 9px

    .d-donors .d-block
      min-height: 350px

</style>

<style>
  .contacts-t-wrap .dataTables_scrollBody {
    transition: all .3s ease-in-out;
  }

  .contacts-t-wrap.contacts-list .d-donors {
    max-height: calc(100vh - 348px);
    overflow: hidden;
  }

  .contacts-t-wrap.contacts-list.contacts-t-wrap-no-banner .d-donors {
    max-height: calc(100vh - 140px);
  }

  .contacts-t-wrap.contacts-list.contacts-t-wrap-no-banner .dataTables_scrollBody {
    max-height: calc(100vh - 335px) !important;
    transition: all .3s ease-in-out;
  }

  .contacts-t-wrap .d-donors .d-block {
    min-height: 450px;
    height: auto;
  }

  .contacts-t-wrap th.sorting {
    white-space: nowrap;
  }

  .contacts-t-wrap div.dataTables_wrapper table.dataTable {
    margin: 0;
  }

  .contacts-t-wrap table.dataTable.dt-checkboxes-select tbody tr {
    cursor: auto;
    height: 64px;
  }

  .contacts-t-wrap table.dataTable.dt-checkboxes-select tbody tr td:first-child {
    cursor: pointer;
  }

  .contacts-t-wrap .check-cwrap {
    padding-left: 18px;
    padding-right: 0;
  }

  .contacts-t-wrap .dataTables_length {
    display: none;
  }
</style>
